/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';

import {AdminResourceRouteContext, readAdminResourceRouteContext} from '../common/controller/admin-resource-route-context';

@Component({
  standalone: false,
  selector: 'adn-line-item-reach-page',
  template: `
    <adn-reach-analysis
      *ngIf="context"
      [model]="context.model"
      [modelComms]="context.modelComms"
      objectType="LINE_ITEM">
    </adn-reach-analysis>
  `
})
export class LineItemReachPageComponent implements OnInit {
  context: AdminResourceRouteContext;

  constructor(private readonly uiRouter: UIRouter) {
  }

  ngOnInit(): void {
    this.context = readAdminResourceRouteContext(this.uiRouter);
  }
}
